import berexempt from '@propertypal/shared/src/resources/icons/ber/berexempt@3x.png';
import { Property } from '@propertypal/shared/src/types/property';
import React, { CSSProperties, FunctionComponent } from 'react';
import { useTheme } from 'styled-components';
import { Text } from '../typography';
import { BerIcon, BerRating, BerTitle, Container, EpcIcon } from './EnergyRatingIcon.style';

interface Props {
  containerStyle?: CSSProperties;
  property: Property;
  hideEpcText?: boolean;
}

const EnergyRatingIcon: FunctionComponent<Props> = (props) => {
  const theme = useTheme();

  if (props.property.epc) {
    return (
      <Container style={props.containerStyle}>
        <EpcIcon data-testid="epcIcon">
          <Text color={theme.white} fontSize={10} aria-label={`EPC Rating ${props.property.epc.ratingShorthand}`}>
            {props.property.epc.ratingShorthand}
          </Text>
        </EpcIcon>

        {!props.hideEpcText && <Text>EPC Rating</Text>}
      </Container>
    );
  }

  if (props.property.berExempt) {
    return (
      <Container style={props.containerStyle}>
        <img src={berexempt.src} data-testid="berExemptIcon" alt="BER Exempt" style={{ width: 100, height: 22 }} />
      </Container>
    );
  }

  if (props.property.ber && props.property.ber.alphanumericRating) {
    return (
      <Container style={props.containerStyle}>
        <BerIcon
          title={`This property has a BER rating of ${props.property.ber.alphanumericRating}`}
          data-testid="berIcon"
        >
          <BerTitle>BER</BerTitle>
          <BerRating rating={props.property.ber.alphanumericRating}>{props.property.ber.alphanumericRating}</BerRating>
        </BerIcon>
      </Container>
    );
  }

  return null;
};

export default EnergyRatingIcon;
